import { Stack, styled as muiStyled } from '@mui/material';

export const Container = muiStyled(Stack)(() => ({
  height: '100%',
  overflow: 'hidden',
}));
